module.exports = __webpack_public_path__ + "img/headerPhone.a9114e7c.svg";